import { logSystem } from 'logger';
import { transportRegistry } from '../Service';
function postRequest(url = ``, data) {
    return fetch(url, {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        redirect: 'follow',
        referrer: `${window.hcstatic.portal_url}/`,
        body: data
    }).then((response) => response.json());
}
const postTransport = {
    fire(r) {
        const promise = new Promise((resolve, reject) => {
            postRequest(r.target, r.data).then((v) => {
                resolve(v);
            }, (e) => {
                logSystem.error(`${r.target} !!!=>`, e);
                reject(e);
            });
        });
        return promise;
    }
};
transportRegistry.set('POST', postTransport);
